import { v4 as uuidv4 } from "uuid";

export const getSessionId = () => {
  const SessionId = localStorage.getItem("sessionId");
  let newSessionId;
  if (!SessionId) {
    newSessionId = uuidv4();
    localStorage.setItem("sessionId", newSessionId);
  }
  return newSessionId;
};
